<!-- src/components/forms/completed/RolesResponsibilitiesCompleted.vue -->
<template>
  <div class="space-y-12 animate-fadeIn">
    
    <!-- 1. Identity Verification -->
    <section>
      <div class="flex items-center gap-3 mb-6">
        <div class="bg-[#20FCF1] p-2 rounded-lg shadow-sm">
          <IdentificationIcon class="h-5 w-5 text-[#0A1630]" />
        </div>
        <h3 class="text-sm font-black uppercase tracking-[0.2em] text-[#0A1630]">1. Personnel Details</h3>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 bg-slate-50 p-8 rounded-[32px] border border-slate-100 shadow-inner">
        <div class="StatCard bg-white">
          <span class="label">Full Name</span>
          <span class="value uppercase">{{ submissionData.name }}</span>
        </div>
        <div class="StatCard bg-white">
          <span class="label">Verified Email</span>
          <span class="value lowercase">{{ submissionData.email }}</span>
        </div>
      </div>
    </section>

    <!-- 2. The Statement -->
    <section>
      <div class="flex items-center gap-3 mb-6">
        <div class="bg-[#20FCF1] p-2 rounded-lg shadow-sm">
          <AcademicCapIcon class="h-5 w-5 text-[#0A1630]" />
        </div>
        <h3 class="text-sm font-black uppercase tracking-[0.2em] text-[#0A1630]">2. Operational Mandate</h3>
      </div>

      <div class="bg-white border border-slate-200 rounded-[40px] p-10 shadow-sm relative overflow-hidden">
        <div class="absolute top-0 left-0 w-2 h-full bg-[#20FCF1]"></div>
        <div class="ql-editor !p-0 text-slate-700" v-html="submissionData.statementText"></div>
      </div>
    </section>

    <!-- 3. Final Sign-Off -->
    <section class="border-t pt-12">
      <div class="flex flex-col md:flex-row justify-between items-end gap-8">
        <div class="space-y-4">
          <div class="flex items-center gap-2">
            <ShieldCheckIcon class="h-5 w-5 text-[#20FCF1]" />
            <p class="text-[10px] font-black uppercase tracking-widest text-[#0A1630]">Accountability Agreement Verified</p>
          </div>
          <div class="p-6 bg-slate-900 rounded-[32px] border border-slate-800 max-w-sm">
            <p class="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-1">Confirmation Statement</p>
            <p class="text-xs text-slate-300 font-medium italic">"I confirm that I have read, understand, and agree to the Roles & Responsibilities Statement as outlined above."</p>
          </div>
        </div>

        <div v-if="submissionData.signatureDataUrl || submissionData.signatureUrl" class="bg-white p-6 rounded-[32px] border border-slate-200 shadow-xl flex flex-col items-center min-w-[260px]">
          <p class="text-[9px] font-black uppercase text-slate-400 mb-4">Authorized Signature Seal</p>
          <img :src="submissionData.signatureDataUrl || submissionData.signatureUrl" class="max-h-20 object-contain mb-4" />
          <div class="w-full h-px bg-slate-100 mb-4"></div>
          <div class="flex flex-col items-center">
            <span class="text-[10px] font-black uppercase text-[#0A1630] tracking-widest">{{ submissionData.name }}</span>
            <span class="text-[9px] font-bold text-slate-400 mt-1 uppercase">{{ formatDate(submissionData.submittedAt) }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { 
  IdentificationIcon, AcademicCapIcon, ShieldCheckIcon 
} from '@heroicons/vue/24/outline';

defineProps({
  submissionData: { type: Object, required: true },
  formatDate: { type: Function, required: true }
});
</script>

<style scoped>
.StatCard { @apply flex flex-col p-6 rounded-[28px] border border-slate-100 shadow-sm; }
.StatCard .label { @apply text-[9px] font-black uppercase text-slate-400 tracking-widest mb-1; }
.StatCard .value { @apply text-sm font-black text-[#0A1630] truncate; }
.animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

:deep(.ql-editor p) { margin-bottom: 1rem; line-height: 1.8; }
</style>